module.exports = __webpack_public_path__ + "static/media/user.7d52eb1d.svg";